import React from 'react';

function Cart(props) {
  return <h1>장바구니</h1>;
}
export default Cart;
